module.exports = __webpack_public_path__ + "assets/images/boundaries/ge2020-logo.svg?v=e8ed1fda";